import { motion } from "framer-motion";

/**
 * Fondo decorativo. Usa un gradiente estático + dos "blobs" que se mueven
 * SOLO con transform (translate), por lo que la animación corre en la GPU
 * y no provoca repaints de pantalla completa (clave para el rendimiento móvil).
 */
export const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 z-[-1] overflow-hidden bg-[linear-gradient(155deg,#f7f8fc_0%,#eef1ff_45%,#f4f5f9_100%)]">
      <motion.div
        className="absolute -left-[20vw] -top-[10vh] h-[60vh] w-[60vh] rounded-full bg-[radial-gradient(circle,rgba(225,14,25,0.18)_0%,transparent_70%)] will-change-transform"
        animate={{ x: [0, 48, 0], y: [0, 32, 0] }}
        transition={{ duration: 20, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -right-[18vw] top-[-12vh] h-[55vh] w-[55vh] rounded-full bg-[radial-gradient(circle,rgba(57,54,125,0.22)_0%,transparent_70%)] will-change-transform"
        animate={{ x: [0, -44, 0], y: [0, 28, 0] }}
        transition={{ duration: 24, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }}
      />

      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(17,24,39,0.25) 1px, transparent 1px), linear-gradient(90deg, rgba(17,24,39,0.25) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
    </div>
  );
};
